import { render, staticRenderFns } from "./previewIP.vue?vue&type=template&id=0fbc0ec8&scoped=true"
import script from "./previewIP.vue?vue&type=script&lang=js"
export * from "./previewIP.vue?vue&type=script&lang=js"
import style0 from "./previewIP.vue?vue&type=style&index=0&id=0fbc0ec8&prod&lang=scss&scoped=true"
import style1 from "./previewIP.vue?vue&type=style&index=1&id=0fbc0ec8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbc0ec8",
  null
  
)

export default component.exports